import CollectionIcon from "src/assets/all-icons/collection-icon.jsx";
import CommunityIcon from "src/assets/all-icons/community-icon.jsx";

import ArtlistIcon from '@/assets/all-icons/artlist-icon';
import ShareIcon from '@/assets/all-icons/share-icon';
import useGoBack from '@/hooks/useGoBack';
import UserProfileImage from '@/shared-components/cards/components/UserProfileImage';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import AppNavigationPage from '@/shared-components/wrappers/components/AppNavigationPage';

import './styles/UserNotFound.css';

export default function UserNotFound() {
  const goBackHandler = useGoBack("/");

  return (
    <>
      <AppNavigationPage>
        <div className="user-not-found__container">
          <div className="user-not-found__main-content">
            <BackArrowIcon className="user-not-found__back" onClick={goBackHandler}/>

            <ShareIcon className="user-not-found__share"/>

            <UserProfileImage className="user-not-found__image"/>

            <span className="user-not-found__text font-size-medium">
                            User not found
            </span>

            <span className="user-not-found__empty-button"/>

            <div className="user-not-found__buttons">
              <CollectionIcon className="user-not-found__icon"/>
              <CommunityIcon className="user-not-found__icon --community"/>
              <ArtlistIcon className="user-not-found__icon"/>
            </div>
          </div>
        </div>
      </AppNavigationPage>
    </>
  );
}
